import styled from 'styled-components';
import { Collapse } from 'antd';

export const Orientation = styled.div`
  margin-bottom: 20px;

  .ant-typography {
    white-space: pre-wrap;
  }
`;

export const ReferencesContent = styled.div`
  min-height: 100px;
`;

export const ReferencesCollapse = styled(Collapse)`
  background: transparent;

  .ant-collapse-item {
    margin-bottom: 12px;
    overflow: hidden;
    border: 1px solid #e8e8e8;
    border-radius: 4px !important;
  }

  .ant-collapse-header {
    display: flex;
    align-items: center !important;
    padding: 14px 40px 14px 16px !important;
    background: #fafafa;
  }

  .ant-collapse-content-box {
    padding: 14px 16px;
    white-space: pre-wrap;
  }
`;

export const ReferenceHeader = styled.div`
  display: flex;
  flex: 1;
  gap: 16px;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const ReferenceData = styled.div`
  display: grid;
  flex: 1;
  grid-template-columns: minmax(160px, 2fr) minmax(130px, 1fr) minmax(120px, 1fr);
  gap: 16px;

  @media (max-width: 768px) {
    width: 100%;
    grid-template-columns: 1fr;
  }
`;

export const ReferenceField = styled.div`
  display: flex;
  min-width: 0;
  flex-direction: column;

  .ant-typography:last-child {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const ReferenceActions = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  .approve-button.ant-btn-primary {
    border-color: #24a95d;
    background: #24a95d;
  }

  @media (max-width: 768px) {
    width: 100%;
    flex-wrap: wrap;
  }
`;

export const ReferenceObservation = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
